export const FEATURES_BASE_NAME = '_bouqs_feature_';

export const FEATURES = {
  test: `${FEATURES_BASE_NAME}rui503`,
};
